import React, { useCallback, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Image } from "react-bootstrap";

import "./GetAppPage.scss";
import { OnboardingSteps, ROUTES } from "../../../utils/constants";
import useVendorDetection from "../../../hooks/useVendorDetection";
import { PhoneVendors } from "../../../utils/vendor";
import DownloadApkModal from "../modals/DownloadApkModal/DownloadApkModal";
import FilledButton, {
  ButtonSizes,
} from "../../../components/dashboard-page/FilledButton/FilledButton";
import ImageHero from "../../../images/hyper-works-best-hero.png";
import ImageHeroIphone from "../../../images/hyper-works-best-hero-iphone.png";
import useNotifications from "../../../hooks/useNotifications";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";
import { useNavigate } from "react-router-dom";
import useDisclosure from "../../../hooks/useDisclosure";
import GetAppButton from "../../../components/GetAppButton/GetAppButton";
import DownloadAndroidAppModal from "../../../components/DownloadAndroidAppModal/DownloadAndroidAppModal";
import { DownloadAppOptionProperty } from "../../../utils/analytics";
import useAnalytics from "../../../hooks/useAnalytics";

function GetAppPage() {
  const navigate = useNavigate();
  const [isApkModalOpen, setIsApkModalOpen] = useState(false);
  const phoneVendor = useVendorDetection();
  const { notificationsAreEnabled } = useNotifications();
  const { goToStep } = useOnboardingSteps();
  const analytics = useAnalytics();
  const {
    isOpen: isAndroidAppDownloadOpen,
    onOpen: openDownloadAndroidApp,
    onClose: closeDownloadAndroidApp,
  } = useDisclosure();

  const handleProceed = useCallback(() => {
    if (!notificationsAreEnabled) {
      goToStep(OnboardingSteps.TURN_ON_NOTIFICATIONS);
      return;
    }
    navigate(ROUTES.ROOT.DASHBOARD);
  }, [goToStep, navigate, notificationsAreEnabled]);

  const onHideApkModal = useCallback(() => {
    handleProceed();
    setIsApkModalOpen(false);
  }, [handleProceed]);

  const onCloseAndroidDownloadModal = useCallback(() => {
    handleProceed();
    closeDownloadAndroidApp();
  }, [closeDownloadAndroidApp, handleProceed]);

  const onGetAppBtnClick = useCallback(() => {
    if (phoneVendor) handleProceed();
  }, [handleProceed, phoneVendor]);

  const handleDownloadApp = useCallback((openPlatformDialog: () => void) => {
    openPlatformDialog();
  }, []);

  const handleRemindMeLater = () => {
    handleProceed();
    analytics.sendDownloadAppOptionsEvent(DownloadAppOptionProperty.SKIP);
  };

  return (
    <Container className="MobileOnly position-relative GetAppPage px-3 d-flex flex-column justify-content-start">
      <div>
        <h1>Hyper works best with the mobile app.</h1>
        <p className="subhead">
          Play 100s of the best games with thousands of gamers and zero ads
        </p>
      </div>
      <Col className="d-flex align-items-center justify-content-center">
        <Image
          src={phoneVendor === PhoneVendors.APPLE ? ImageHeroIphone : ImageHero}
          alt="hyper dashboard"
          width="75%"
        />
      </Col>
      <div className="mb-3">
        <div className="d-flex justify-content-center go-btn-container mt-0">
          <GetAppButton
            openDownloadAndroidApp={() =>
              handleDownloadApp(openDownloadAndroidApp)
            }
            onBtnClick={onGetAppBtnClick}
          />
          <FilledButton
            size={ButtonSizes.MD}
            style={{ background: "#191040", marginTop: 20 }}
            onClick={handleRemindMeLater}
          >
            Remind me later
          </FilledButton>
        </div>
      </div>
      <DownloadApkModal show={isApkModalOpen} onHide={onHideApkModal} />
      <DownloadAndroidAppModal
        isOpen={isAndroidAppDownloadOpen}
        onClose={onCloseAndroidDownloadModal}
      />
    </Container>
  );
}

export default GetAppPage;
